import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

function DeleteAccountPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const auth = getAuth();
      // Sign in (or reauth) with provided credentials so we have a valid ID token.
      const credential = await signInWithEmailAndPassword(auth, email, password);
      const current = credential.user;
      if (!current) throw new Error('No user returned.');

      const token = await current.getIdToken(true);
      const fn = httpsCallable(functions, 'deleteAccount');
      await fn({ idToken: token });

      await signOut(auth);
      setSuccess(true);
      setEmail('');
      setPassword('');
    } catch (err) {
      const msg = err?.message || 'Failed to delete account.';
      setError(msg);
    }

    setLoading(false);
  };

  return (
    <div style={{ maxWidth: '420px', margin: '3rem auto', padding: '2rem', background: '#f8faf9', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <h2 style={{ color: '#007b5e', marginBottom: '1.5rem', textAlign: 'center' }}>Delete My Account</h2>
      <p style={{ marginBottom: '1rem', color: '#444', textAlign: 'center' }}>
        Enter your email and password to permanently delete your account and data.
      </p>
      <form onSubmit={handleDelete} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
          style={{ padding: '0.75rem', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
          style={{ padding: '0.75rem', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        {error && <div style={{ color: '#c0392b', textAlign: 'center' }}>{error}</div>}
        {success && <div style={{ color: '#007b5e', textAlign: 'center', fontWeight: 'bold' }}>ACCOUNT DELETED</div>}
        <button
          type="submit"
          disabled={loading}
          style={{
            background: '#c0392b',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '0.85rem',
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          {loading ? 'Deleting...' : 'Delete my account'}
        </button>
      </form>
      <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#666', textAlign: 'center' }}>
        If you signed up with Google, please use the Client Dashboard delete option instead.
      </p>
    </div>
  );
}

export default DeleteAccountPage;
